<template lang="html">
  <div>
    About
  </div>
</template>

<script>
export default {
  name: 'about'
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/About.vue